import React, { useEffect, useContext, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { DataContext } from "../../providers/DataProvider";
import { DataHandlerContext } from "../../providers/DataHandlerProvider";
import api from "../auth/AddAuthHeader";
import TopTitle from "../buttons/TopTitle";

function MarkFormEdit() {
  const {
    eventSeriesData,
    eachEventSerieData,
    handlePopulateEventSeries,
    handlePopulateEachEventSeries,
    loading,
    error,
    markFormObject,
    populateEachMarkForm,
    handlePopulateEachMarkForm,
  } = useContext(DataContext);
  const { handleSubmitMarkFormEdit, errorSubmit, loadingSubmit } =
    useContext(DataHandlerContext);

  const [apiDataHandle, setApiDataHandle] = useState({});
  const [sucesssFullySubmitted, setSucesssFullySubmitted] = useState(false);

  const { formid } = useParams();

  const handleInputChange = (e) => {
    const { name, type, checked, value } = e.target;
    setApiDataHandle((prev) => {
      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };

  const handleSubmitMarkForm = async (e, id, data) => {
    e.preventDefault();
    try {
      const response = await handleSubmitMarkFormEdit(id, data);
      if (response.status === 200) {
        setSucesssFullySubmitted(true);
      }
      setTimeout(() => {
        setSucesssFullySubmitted(false);
      }, 3000);
    } catch (error) {}
  };

  useEffect(() => {
    handlePopulateEachMarkForm(formid);
  }, []);

  return (
    <div className="flex flex-col   p-10 bg-neutral-10">
      <div className="  flex justify-center  mt-8   ">
        {errorSubmit && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded  fixed top-0 mt-5"
            role="alert"
          >
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">
              An error has been trying to save the data.
            </span>
          </div>
        )}
        {sucesssFullySubmitted && (
          <div
            className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded fixed top-0 mt-5 "
            role="alert"
          >
            <strong className="font-bold">Success! </strong>
            <span className="block sm:inline">
              Your data has been saved successfully.
            </span>
          </div>
        )}
      </div>
      <TopTitle title="Edit Mark Form" />

      <div className="flex justify-between md:px-[20rem]     py-10 items-center md:space-x-4">
        <input
          type="text"
          onChange={handleInputChange}
          name="title"
          value={apiDataHandle.title || ""}
          placeholder={populateEachMarkForm.title}
          className="text-5xl font-extrabold border w-full border-black px-4 py-2"
        />
      </div>

      <div className="md:px-[20rem] items-center ">
        <div className="flex items-center">
          <label className=" py-2 mt-4 flex-1 text-lg">Copper Tag:</label>
          <input
            onChange={handleInputChange}
            name="copper_tag"
            value={apiDataHandle.copper_tag ?? populateEachMarkForm.copper_tag}
            className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
            type="text"
            placeholder="Enter copper tag"
          />
        </div>
      </div>
      <br />
      <div className=" md:px-[20rem]  items-center md:space-x-4">
        <form className="flex flex-col ">
          <div className=" items-center">
            <label className="  flex-1 text-lg">Email Copy</label>

            <p className="text-sm text-gray-500">
              This template will be used to send emails to the users who fill
              out the form.
            </p>
            <br />
            <label className="  flex-1 text-lg">
              Enter an email you'd like to forward the submissions:
            </label>
            <p className="text-sm text-gray-500">
              Make sure the email format is correct <br />
            </p>
            <input
              type="text"
              onChange={handleInputChange}
              name="email_forward"
              value={
                apiDataHandle.email_forward !== undefined
                  ? apiDataHandle.email_forward
                  : populateEachMarkForm.email_forward || ""
              }
              className="text-2xl font-extrabold border w-full border-black "
            />
            <br />
            <label className="  flex-1 text-lg">Subject:</label>
            <br />

            <input
              type="text"
              onChange={handleInputChange}
              name="email_subject"
              value={apiDataHandle.email_subject || ""}
              placeholder={populateEachMarkForm.email_subject}
              className="text-2xl font-extrabold border w-full border-black "
            />
            <br />
            <br />

            <br />
            <label className="  flex-1 text-lg">
              Does the email include downloadable content?
            </label>
            <br />

            <input
              type="checkbox"
              onChange={handleInputChange}
              name="donwloadable_content"
              checked={
                apiDataHandle.donwloadable_content !== undefined
                  ? apiDataHandle.donwloadable_content
                  : populateEachMarkForm.donwloadable_content || false
              }
              placeholder={populateEachMarkForm.donwloadable_content || ""}
              className="text-2xl font-extrabold border w-full border-black "
            />
            <br />
            <br />

            <label className="  flex-1 text-lg">Email:</label>

            <textarea
              onChange={handleInputChange}
              name="email_template"
              value={
                apiDataHandle.email_template ??
                populateEachMarkForm.email_template
              }
              className=" px-4 py-2 mt-4 flex-1 border-[2px] border-black w-full"
              type="text"
              placeholder="Enter email template here"
              rows="10"
            />
          </div>

          <button
            disabled={Object.keys(apiDataHandle).length === 0 || loadingSubmit}
            onClick={(e) => {
              handleSubmitMarkForm(e, populateEachMarkForm.id, apiDataHandle);
            }}
            className={`border-[2px] px-4 py-2 mt-4 font-medium rounded-md transition-all duration-200 sticky bottom-4 shadow-sm ${
              Object.keys(apiDataHandle).length === 0 || loadingSubmit
                ? "bg-blue-100 border-blue-300 text-blue-400 cursor-not-allowed opacity-70"
                : "bg-blue-600 border-blue-700 text-white hover:bg-blue-700 active:bg-blue-800"
            }`}
          >
            {loadingSubmit ? (
              <span className="flex items-center gap-2">
                <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Loading...
              </span>
            ) : (
              "Save changes"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default MarkFormEdit;
